import { StringIndexedObject } from '@kanda-libs/ks-design-library';
import {
  JobInfo,
  JobItem,
  PreferenceMap,
} from '@kanda-libs/ks-frontend-services';

import { cleanObject } from 'utils';
import { BASE_ITEM } from './Fields/constants';
import { EnquiryWorkDetailsFormValues } from './useEnquiryWorkDetailsForm';

export const formatJobInfo = (jobInfo: JobInfo): JobInfo => {
  const { work_type: workType, job_items: jobItems, ...rest } = jobInfo;

  const formattedItems: JobItem[] = jobItems.map((item) => ({
    ...BASE_ITEM,
    ...item,
    title:
      item?.title || `Enquiry from customer for ${workType.replace(/_/g, ' ')}`,
  }));

  return {
    job_items: formattedItems,
    work_type: workType,
    ...rest,
  };
};

export interface FormattedEnquiryWorkDetailsBodies {
  jobInfo: JobInfo;
  consumerPreferences: PreferenceMap;
}

export const formatEnquiryFormValuesToEnquiryBody = (
  formValues: StringIndexedObject<EnquiryWorkDetailsFormValues>,
): FormattedEnquiryWorkDetailsBodies => {
  const fv = formValues as unknown as EnquiryWorkDetailsFormValues;
  const { job_info: jobInfo, consumer_preferences: consumerPreferences } = fv;
  return cleanObject({
    jobInfo: formatJobInfo(jobInfo),
    consumerPreferences,
  });
};
